import type { HTMLAttributes } from 'react';

import { ClassNames } from '@/shared/classNames';

type SeparatorProperties = HTMLAttributes<HTMLDivElement> & {
  orientation?: 'horizontal' | 'vertical';
};

export const Separator = ({ className, orientation = 'horizontal', ...properties }: SeparatorProperties) => (
  <div
    aria-orientation={orientation}
    className={ClassNames(orientation === 'vertical' ? 'bg-line h-full w-px' : 'bg-line h-px w-full', className)}
    role="separator"
    {...properties}
  />
);
